import React from "react";
import { AxiosError } from "axios";
import { MakeRequest } from "../DataUtil";
import DataGrid from "../DataGrid/DataGrid";
import { userContext } from "../Menu/MenuPicker";

interface Props {
  Title: string;
  MaxRows: number;
}

interface State {
  renderCount: number;
  user: any;
  sizeOptions: any;
}

class ShippingGrid extends React.Component<Props, State> {
  static contextType = userContext;
  constructor(props: Props) {
    super(props);
    this.state = {
      renderCount: 0,
      user: {},
      sizeOptions: [],
    };
  }
  loadSizes = async (): Promise<any> => {
    const successCallback = (result: any): void => {
      if (result && result.Success) {
        let options = result.Data.map((item: any) => {
          return { label: item.SizeValue, value: item.SizeId };
        });
        this.setState({
          sizeOptions: options,
        });
      }
    };
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        console.log(error.response ? error.message : "Unknown Error");
      }
    };
    MakeRequest({
      url: "Painting/GetAllSizes",
      method: "get",
      data: {},
      successCallback,
      errorCallback,
    });
  };
  buildColumns(): any {
    if (!this.state.sizeOptions && this.state.sizeOptions === undefined) {
      this.setState({
        renderCount: this.state.renderCount + 1,
      });
    }
    const columnHeaders = [
      {
        DataPropertyName: "Id",
        IsIdColumn: true,
        ShowColumn: false,
      },
      {
        DataPropertyName: "SelectedShippingTypeName",
        ColumnAliasName: "Type",
        InputType: "text",
        ShowColumn: true,
        CanEdit: false,
      },
      {
        DataPropertyName: "Price",
        ColumnAliasName: "Price (£)",
        InputType: "number",
        IsRequired: true,
        ShowColumn: true,
        CanEdit: true,
      },
      {
        DataPropertyName: "SizeId",
        ColumnAliasName: "",
        InputType: "text",
        ShowColumn: false,
      },
      {
        DataPropertyName: "SizeValue",
        DataPropertyValue: "SizeId",
        ColumnAliasName: "Size (cm)",
        InputType: "select",
        IsRequired: true,
        ShowColumn: true,
        CanEdit: true,
        Options: this.state.sizeOptions,
      },
      {
        DataPropertyName: "Enabled",
        ColumnAliasName: "Enabled",
        InputType: "checkbox",
        ShowColumn: true,
        CanEdit: true,
        BooleanText: { TrueState: "Yes", FalseState: "No" },
      },
      {
        DataPropertyName: "",
        ColumnAliasName: "Actions",
        ShowColumn: true,
        IsActionsColumn: true,
      },
    ] as any;

    return columnHeaders;
  }

  componentDidMount(): void {
    this.loadSizes().then(() => {
      let context: any = this.context;
      this.setState({
        user: context.user,
        renderCount: this.state.renderCount + 1,
      });
    });
  }

  render() {
    return (
      <div className="wrapper">
        <div className="section latest-offers">
          <div className="container">
            <h3 className="section-title">{this.props.Title}</h3>
            <hr />
            <DataGrid
              key={"dataGrid_" + this.state.renderCount}
              ColumnArray={this.buildColumns()}
              SelectAPI="Painting/GetAllShipping"
              UpdateAPI="Admin/UpdateShipping"
              MaxNumberOfRowsPerPage={this.props.MaxRows}
              GridName="shippingValues"
              PrimaryKeyName="Id"
              LoadOnScroll={false}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ShippingGrid;
